import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconX(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M18 6l-12 12" />
			<path d="M6 6l12 12" />
		</Icon>
	);
}
